<template>
  <div class="navbar-container d-flex align-items-center w-100">

    <!-- Mobile: Menu toggle (large tap target) -->
    <b-link
      class="app-shell-menu-toggle d-xl-none d-flex align-items-center justify-content-center"
      aria-label="Open menu"
      @click="toggleVerticalMenuActive"
    >
      <feather-icon icon="MenuIcon" size="22" />
    </b-link>

    <!-- Desktop: Bookmarks -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <bookmarks />
    </div>

    <!-- Contact info (desktop only) -->
    <div class="navbar-contact-bar d-none d-xl-flex">
      Treasure Home · Tel: +43 1 9582335 · Email: Office@treasurehome.at
    </div>

    <!-- Right: Actions -->
    <b-navbar-nav class="nav align-items-center ml-auto app-shell-nav-actions">
      <locale />
      <dark-toggler class="d-none d-lg-block" />
      <notification-dropdown />
      <branches-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import BranchesDropdown from '@core/layouts/components/app-navbar/components/BranchesDropdown'
import HostawayNotificationDropdown from "@core/layouts/components/app-navbar/components/HostawayNotificationDropdown";

export default {
  components: {
    BranchesDropdown,
    BLink,
    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    // eslint-disable-next-line vue/no-unused-components
    SearchBar,
    DarkToggler,
/*
    HostawayNotificationDropdown,
*/
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
